import React from 'react';
import {Card, Col, Container, Row} from 'react-bootstrap';
import Beer from '../assets/images/others/Beer.jpg';
import Bones from '../assets/images/others/Bones_sm.jpg';
import CeskyKrumlov from '../assets/images/others/CeskyKrumlov_sm.jpg';
import Glass from '../assets/images/others/Glass_sm.jpg';
import GlassBeer from '../assets/images/others/GlassBeer2_sm.jpg';
import Terezin from '../assets/images/others/Terezin_sm.jpg';
import Popup from 'reactjs-popup';
import TourCardModal from '../components/tourCardModal';
import {translate} from 'react-switch-lang';
import PropTypes from 'prop-types';
import {TOURS_OTHERS_CZ} from '../shared/TOURS_OTHERS_CZ';
import {TOURS_OTHERS_EN} from '../shared/TOURS_OTHERS_EN';
import {isEnglishSet, metaTagsCZ, metaTagsEN} from '../shared/utils';
import DocumentMeta from 'react-document-meta';

class OtherTours extends React.Component {
  render() {
    const {t} = this.props;
    const metaTags = isEnglishSet() ? metaTagsEN.otherTours : metaTagsCZ.otherTours;
    const OTHER_TOURS = isEnglishSet() ? TOURS_OTHERS_EN : TOURS_OTHERS_CZ;
    const OTHER_TOURS_IMAGES = [
      CeskyKrumlov,
      Terezin,
      Beer,
      Beer,
      GlassBeer,
      Bones,
      Bones,
      Bones,
      Glass,
      GlassBeer,
    ];
    window.scrollTo(0, 0);
    return (
      <DocumentMeta {...metaTags}>
        <Container className="mt-5 mb-5 pt-5 pb-5">
          <h3 className="">{t('pages.otherTours.title')}</h3>
          {t('pages.otherTours.legend')}
          <br />
          <br />
          {t('pages.otherTours.notes')}
          <Row noGutters className="pl-2">
            {OTHER_TOURS.map((value, index) => {
              return (
                <Col xs={12} md={6} xl={4} className="pt-2 pr-2 mb-2" key={index}>
                  <Popup
                    trigger={
                      <Card className="tour-card">
                        <Card.Img variant="top" src={OTHER_TOURS_IMAGES[index]} />
                        <Card.Body>
                          <Card.Title>{value.name}</Card.Title>
                          <Card.Text>{value.description}</Card.Text>
                        </Card.Body>
                        <Card.Footer>
                          <span className="font-weight-bold">
                            {t('widgets.tour_card.duration')}
                          </span>{' '}
                          {value.duration + 'h'}
                          <br />
                          <span className="font-weight-bold">
                            {t('widgets.tour_card.price')}
                          </span>{' '}
                          {value.price}
                        </Card.Footer>
                      </Card>
                    }
                    modal
                    closeOnDocumentClick>
                    <TourCardModal data={value} image={OTHER_TOURS_IMAGES[index]} />
                  </Popup>
                </Col>
              );
            })}
          </Row>
        </Container>
      </DocumentMeta>
    );
  }
}

OtherTours.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate(OtherTours);
